import Vue from 'vue';
import moment, { displayDate } from '../util/date-time';

Vue.filter('defaultDate', (value, format, breakLine = false, keepLocalTime = false) => {
    if (value) {
        moment.locale('pt');

        if (format === 'fromNow') {
            return displayDate(value, keepLocalTime).fromNow();
        } else {
            if (!format) {
                format = 'DD/MM/YYYY';
            }

            if (breakLine) {
                format = format.replace(' ', '[<br />]');
            }

            return displayDate(value, keepLocalTime).format(format);
        }
    }

    return value;
});
